<main data-aos="fade-in">
    <h1 i18n="@@title-gallery">Gallery</h1>
    <div class="card-container" *ngIf="paintings else indicator">
        <div (click)="openImg(painting.id)" class="card" *ngFor="let painting of paintings;"
            style=" background-image: url(https://pet-api-vercel.vercel.app/{{painting.pImage}});">
            <div class="info">
                <p i18n="@@gallery-name">Name: {{painting.name}}</p>
                <p i18n="@@gallery-dimensions">Dimensions: {{painting.dimensions}}</p>
                <p i18n="@@gallery-description">Description: {{painting.description}}</p>
                <p i18n="@@gallery-year">Year: {{painting.year}}</p>
                <p i18n="@@gallery-available">Available: {{painting.available}}</p>
            </div>

        </div>
    </div>
    <ng-template #indicator>
        <h3>Loading...Please wait </h3>
    </ng-template>


    <a data-aos="appear" data-aos-anchor-placement="center-top" href="/works">
        <div class="up">ᐃ</div>
    </a>


</main>